import { createSelector } from "reselect";

export const shopsSelector = (state) => state?.shops?.shops || [];

export const sendToChannelAllowedShopsSelector = createSelector(
  [shopsSelector],
  (shops) => shops.filter((s) => ["2", "13"].includes(s?.platformId))
);
